import PicturesApp from 'station/components/picture/PicturesApp'
import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import useTitle from 'utils/customHook/useTitle'
import i18n from 'simple-react-i18n'
import { getStationTitle } from 'utils/StationUtils'

const PiezometryPicturesApp = ({

}) => {
    const {
        piezometer,
        piezometers,
    } = useSelector(store => ({
        piezometer: store.StationReducer.piezometer,
        piezometers: store.PiezometryReducer.piezometersLight,
    }), shallowEqual)

    useTitle(() => [{
        title: i18n.piezometry,
        href: 'piezometry',
    }, {
        title: getStationTitle(piezometer),
        href: `station/piezometry/${piezometer?.id}`,
    }, {
        title: i18n.picturesAndDocuments,
        href: `station/piezometry/${piezometer?.id}/picture`,
    }], [piezometer])

    return (
        <PicturesApp
            stations={piezometers}
            station={piezometer}
            stationType='piezometry'
        />
    )
}

export default PiezometryPicturesApp